
    const data = {"name":"src/core/icons/arrow-up-thin","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M7.03 9.97h4v8.92l2.01.03V9.97h3.99l-5-5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            